import React from "react";
import { Formik, Form } from "formik";
import { Stack } from "office-ui-fabric-react";
import { useDriverForm } from "../hooks/useDriverForm";
import { validationSchemaDrivers } from "../actions/validationSchemas";
import NewFormField from "../../common/layout/form/NewFormField";
import NewFormBtns from "../../common/layout/form/NewFormBtns";
import ActivityIndicator from "../../common/layout/ActivityIndicator";
import MessageContainer from "../../auth/components/register/forms/MessageContainer";
import { useTranslation } from 'react-i18next';

const DriverForm: React.FC = () => {
  const { t } = useTranslation('admin');
  const {
    handleSubmit,
    initValues,
    cancelForm,
    selectedDrivers,
    loading
  } = useDriverForm();

  const validationTranslations = {
    lastNameRequired: t('drivers.validation.lastNameRequired') as string,
    firstNameRequired: t('drivers.validation.firstNameRequired') as string,
    phoneRequired: t('drivers.validation.phoneRequired') as string,
    phoneInvalid: t('drivers.validation.phoneInvalid') as string,
    emailRequired: t('drivers.validation.emailRequired') as string,
    emailInvalid: t('drivers.validation.emailInvalid') as string,
  };

  return (
    <Formik
      initialValues={initValues}
      onSubmit={handleSubmit}
      validationSchema={validationSchemaDrivers(validationTranslations)}
    >
      {({ handleSubmit }) => (
        <Form translate="yes" onSubmit={handleSubmit}>
          <Stack>
            <NewFormField name="lastName" label={t('drivers.form.lastName') as string} />
            <NewFormField name="firstName" label={t('drivers.form.firstName') as string} />
            <NewFormField name="phone" label={t('drivers.form.phone') as string} />
            <NewFormField name="email" label={t('drivers.form.email') as string} />
            <NewFormBtns
              cancelForm={cancelForm}
              submitBtnText={selectedDrivers[0] ? t('drivers.form.save') as string : t('drivers.form.add') as string}
              disabled={loading}
              positionAbsolute={true}
            />
          </Stack>
          {loading ? <ActivityIndicator /> : <MessageContainer />}
        </Form>
      )}
    </Formik>
  );
};

export default DriverForm;